import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendar } from "react-icons/fa";

const MyDatePicker = props => {
    const { selected, onDateChange, name, isInvalid, children, disabled } = props;
    return (
        <div className="datepickerWrapper">
            <DatePicker
                className={isInvalid ? "form-control is-invalid" : "form-control"}
                selected={selected}
                dateFormat="dd-MMM-yyyy"
                isClearable={selected}
                disabled={disabled}
                placeholderText="DD-MMM-YYYY"
                onChange={date => onDateChange(name, date)}
                minDate={new Date(1900, 1, 1)}
                maxDate={new Date(2999, 12, 31)}
            >
            </DatePicker>
            <FaCalendar></FaCalendar>
            {children}
        </div>
    )
}
export const FromToDatePicker = props => {
    const { selected, subValue, onChange, name, isInvalid, children, disabled } = props;
    return (
        <div className="datepickerWrapper">
            <DatePicker
                className={isInvalid ? "form-control is-invalid" : "form-control"}
                selected={selected}
                isClearable={selected}
                dateFormat="dd-MMM-yyyy"
                disabled={disabled}
                placeholderText="DD-MMM-YYYY"
                onChange={onChange}
                onChangeRaw={(e) => e.preventDefault()}
                min="1970-01-01"
                max="2999-12-31"

            >
            </DatePicker>
            {selected && <FaCalendar style={{ marginRight: "-6px", marginTop: "-2px" }} ></FaCalendar>}
            {!selected && <FaCalendar style={{ marginRight: "-19px", marginTop: "-2px" }} ></FaCalendar>}

            {children}
        </div>
    )
}
export default MyDatePicker;